(function() {
  'use strict';

  $(document).ready(function () {

    $('ul.logged-in-menu').on('mouseenter', function () {
      $(this).addClass('active');
    }).on('mouseleave', function () {
      $(this).removeClass('active');
    });

  });

})();